// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1___6b7e74a3a342554a080","cls2":"mentions_milestone_ping-cls2___8626d0005224dfbe78c mentions_milestone_ping-cls1___6b7e74a3a342554a080"};